$(document).ready(function () {

    $('#Position').change(function () {

        var JobType = $(this).children("option:selected").val();

        if (JobType == 'Mağazalar' || JobType == null) {

            //görev tiplerini gizle
            $('#TamZamanli').hide("slow"); 
            $('#Staj').hide("slow");
            $('#TamZamanliLabel').hide("slow");
            $('#StajLabel').hide("slow");

            //mağaza seçilince merkez departman değerleri silinsin
            $('#Department option[value="Lütfen Seçiniz"]').remove();
            $('#Department option[value="Bilgi İşlem"]').remove();
            $('#Department option[value="E-Ticaret"]').remove();
            $('#Department option[value="Finans"]').remove();
            $('#Department option[value="İnsan Kaynakları"]').remove();
            $('#Department option[value="Lojistik"]').remove();
            $('#Department option[value="Marka"]').remove();
            $('#Department option[value="Muhasebe"]').remove();
            $('#Department option[value="Üretim"]').remove();
            $('#Department option[value="Ürün Yönetimi"]').remove();
            $('#Department option[value="Perakende"]').remove();
            $('#Department option[value="Tasarım"]').remove();
            $('#Department option[value="Yurtdışı Pazarlama / Satış"]').remove();

            //mağaza seçilince aşağıda ki option değerleri departman bilgisi olarak atansın
            $('#Department').append('<option value = "Lütfen Seçiniz" selected="selected" disabled>Lütfen Seçiniz</option>');
            $('#Department').append('<option value = "Müdür">Müdür</option>');
            $('#Department').append('<option value = "Müdür Yardımcısı">Müdür Yardımcısı</option>');
            $('#Department').append('<option value = "Full-Time Satış Temsilcisi">Full-Time Satış Temsilcisi</option>');
            $('#Department').append('<option value = "Part-Time Satış Temsilcisi">Part-Time Satış Temsilcisi</option>');
        }
        else if (JobType == 'Merkez') {

            //görev tiplerini göster
            $('#TamZamanli').show("slow");
            $('#Staj').show("slow");
            $('#TamZamanliLabel').show("slow");
            $('#StajLabel').show("slow");

            //merkez seçilince mağaza departman bilgileri silinsin
            $('#Department option[value="Lütfen Seçiniz"]').remove();
            $('#Department option[value="Müdür"]').remove();
            $('#Department option[value="Müdür Yardımcısı"]').remove();
            $('#Department option[value="Full-Time Satış Temsilcisi"]').remove();
            $('#Department option[value="Part-Time Satış Temsilcisi"]').remove();

            //merkez seçilince aşağıda ki option değerleri departman olarak atansın
            $('#Department').append('<option value = "Lütfen Seçiniz" selected="selected" disabled>Lütfen Seçiniz</option>');
            $('#Department').append('<option value = "Bilgi İşlem">Bilgi İşlem</option>');
            $('#Department').append('<option value = "E-Ticaret">E-Ticaret</option>');
            $('#Department').append('<option value = "Finans">Finans</option>');
            $('#Department').append('<option value = "İnsan Kaynakları">İnsan Kaynakları</option>');
            $('#Department').append('<option value = "Lojistik">Lojistik</option>');
            $('#Department').append('<option value = "Marka">Marka</option>');
            $('#Department').append('<option value = "Muhasebe">Muhasebe</option>');
            $('#Department').append('<option value = "Üretim">Üretim</option>');
            $('#Department').append('<option value = "Ürün Yönetimi">Ürün Yönetimi</option>');
            $('#Department').append('<option value = "Perakende">Perakende</option>');
            $('#Department').append('<option value = "Tasarım">Tasarım</option>');
            $('#Department').append('<option value = "Yurtdışı Pazarlama / Satış">Yurtdışı Pazarlama / Satış</option>');
        }
    });

    var PlaceHolderElement = $('#PlaceHolderHere');

    //button üzerinden verileri getirme
    $('a[data-toggle="ajax-modal"]').click(function (event) {

        var url = $(this).attr('data-url');

        var decoded = decodeURIComponent(url);

        $.get(decoded).done(function (data) {

            PlaceHolderElement.html(data);
            PlaceHolderElement.find('.modal').modal('show');

        });
    });

    $(".CareerForm .ddl_sehir").live("change", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/p/Career/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                $('#TownID option').remove();

                $('#TownID').append($("<option></option>")
                    .attr("value", "")
                    .text("Lütfen Seçiniz")
                );

                for (var i = 0; i < dt.length; i++) {
                    $('#TownID').append(new Option(dt[i].Name, dt[i].ID));
                }

                $(".ajaxilce").hide();
            }
        });
    });

});